import { c as _c } from "react/compiler-runtime";
import { toast } from '@systemeio/ui';
import { NEWSLETTERS_API } from 'modules/newsletters/single/api/newsletters-api';
import { NewsletterId } from 'modules/newsletters/single/types/newsletter-interface';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
export const useSendNewsletter = () => {
  const $ = _c(4);
  const {
    t
  } = useLocoTranslation();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.post
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== fetcher || $[2] !== t) {
    t1 = {
      fetcherSendNewsletter: async id => {
        ;
        try {
          await fetcher(`${NEWSLETTERS_API}/send/${id}`);
          toast.success(t("dashboard.newsletter_editor.was_sent_message"));
        } catch (t2) {
          const e = t2;
          throw e;
        }
      }
    };
    $[1] = fetcher;
    $[2] = t;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
};